const initialState = {
  loading: false,
};

const loadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING_SHOW":
      return {
        ...state,
        loading: true,
      };
    case "LOADING_HIDE":
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default loadingReducer;
